import { Suspense, useState } from 'react';
import { useLoaderData, json, defer, Await } from 'react-router-dom';

import Advertise from '../components/Advertise.jsx';

import classes from '../components/AdvertiseServices.module.css';

import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';
import { initEditState } from '../util/advertiseEditState.jsx';

function AdvertisePage() {
  const info = useLoaderData();

  const [editState, setEditState] = useState(initEditState());

  return (
    <div className={classes.serviceslist}>
      <span><h2 style={{ textAlign: 'center' }}>Advertisement Information</h2></span>
      <span>
        <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
          <Await
            resolve={info.ad}
            children={(loadedAd) => (<Advertise ad={loadedAd} editState={editState} setEditState={setEditState} />)}
          />
        </Suspense>
      </span>
    </div>
  );
}

export default AdvertisePage;

async function loadAd() {
  console.log('loadAd: start');
  const token = getAuthToken();
  const response = await fetch(`https://${backend}/advertise`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw json(
      { message: 'Could not query the current advertisement.' },
      {
        status: 500,
      }
    );
  } else {
    const resData = await response.json();
    //console.log(`loadAd: ${JSON.stringify(resData)}`);
    return resData;
  }
}

export function loader() {
  return defer({
    ad: loadAd(),
  });
}
